<template>
    <icon-radio-group-input
        :columns="2"
        :items="mappedRoles"
        value-key-name="id"
        label-key-name="name"
        icon-key-name="icon"
    />
</template>

<script setup lang="ts">
    import QueryStatsIcon from '@keyvue/one-material-icons/icons/query_stats.svg?component';
    import CampaignIcon from '@keyvue/one-material-icons/icons/campaign.svg?component';
    import PieChartIcon from '@keyvue/one-material-icons/icons/pie_chart.svg?component';
    import TacticIcon from '@keyvue/one-material-icons/icons/tactic.svg?component';
    import { IconRadioGroupInput } from '@keyvue/one-ui';
    import { AvailableAIRole } from '@keyvue/one-api-client';
    import useClient from '@composables/useClient';
    import { computed } from 'vue';

    const { client } = useClient();

    const roles = await client.getCollection<AvailableAIRole>(AvailableAIRole);

    const icons = {
        tactic: TacticIcon,
        pieChart: PieChartIcon,
        campaign: CampaignIcon,
        queryStats: QueryStatsIcon,
    };

    const mappedRoles = computed(() => (roles.data.map(((role) => ({
        ...role,
        icon: icons[role.icon ?? 'tactic'],
    })))));
</script>
